import { render, staticRenderFns } from "./DeviceReferentialKpiComponent.vue?vue&type=template&id=bfd3933e&"
import script from "./DeviceReferentialKpiComponent.vue?vue&type=script&lang=js&"
export * from "./DeviceReferentialKpiComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports